/* eslint-disable react/prop-types */
import { ExternalLink, Lock } from 'lucide-react';
import { Dialog, DialogBody, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';

const OAK_SITE = 'https://oak.legal';

/**
 * What a guest sees on clicking a greyed-out menu item. The item is a fixed
 * label: there is no page, route or data behind it. This panel is the whole
 * response.
 */
const OakFeaturesDialog = ({ feature, firmName, onClose }) => (
  <Dialog open={Boolean(feature)} onOpenChange={(open) => !open && onClose()}>
    <DialogContent className="max-w-md">
      <DialogHeader>
        <DialogTitle className="flex items-center gap-2">
          <Lock size={16} className="text-gray-500" />
          {feature ? `${feature} is part of OAK Legal` : 'Part of OAK Legal'}
        </DialogTitle>
      </DialogHeader>
      <DialogBody className="flex flex-col gap-3 text-2sm text-gray-700 !shadow-none !border-0">
        <p>
          {firmName || 'Your firm'} runs its practice on OAK Legal. This portal gives you secure access to
          the documents they share with you.
        </p>
        <p>
          The rest of the platform is built for law firms: matters and contacts, calendars, billing,
          documents, e-signatures and reports, all in one place.
        </p>
        <div className="flex flex-col gap-2 rounded-md bg-gray-100 p-3">
          <span className="font-medium text-gray-900">Does your firm need a practice management system?</span>
          <a href={OAK_SITE} target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-dark w-fit">
            Learn about OAK Legal <ExternalLink size={14} />
          </a>
        </div>
      </DialogBody>
    </DialogContent>
  </Dialog>
);

export { OakFeaturesDialog, OAK_SITE };
